import { roleCategories } from 'utils/constants';

export const routesFilter = currentRole => route =>
    route.role.includes(currentRole) || route.role.length === 0;

export const routeMaps = {
    [roleCategories.SERVICERS]: [
        'dashboard',
        'subscriptions',
        'investors',
        'sent-subscriptions',
        'investor-accounts',
        'sgp-companies',
        'promoters',
        'servicer-users',
        'provider-users',
        'promoter-users',
        'distributors',
        'networks',
        'fund-management',
        'fund-calls',
        'closings',
        'distributions',
        'reporting',
        'statements',
        'direct-debit-to-funds',
        'transfer-to-funds',
        'sent-messages',
    ],
    [roleCategories.PROVIDERS]: ['dashboard', 'subscriptions', 'investors', 'provider-users'],
    [roleCategories.PROMOTERS]: [
        'dashboard',
        'subscriptions',
        'investors',
        'investor-accounts',
        'promoter-users',
        'distributors',
        'direct-debit-to-funds',
        'transfer-to-funds',
    ],
    [roleCategories.DISTRIBUTORS]: [
        'homepage',
        'dashboard',
        'subscriptions',
        'investors',
        'investor-accounts',
        'distributor-users',
        'distributor-documents',
        'distributor-remunerations',
        'reporting',
        'communication',
        'direct-debit-to-funds',
        'transfer-to-funds',
        'sent-messages',
    ],
    [roleCategories.ADMIN_DISTRIBUTORS]: [
        'homepage',
        'dashboard',
        'subscriptions',
        'investors',
        'investor-accounts',
        'distributor-users',
        'distributor-documents',
        'distributor-remunerations',
        'reporting',
        'communication',
        'direct-debit-to-funds',
        'transfer-to-funds',
        'sent-messages',
    ],
    [roleCategories.INVESTORS]: [
        'homepage',
        'portfolio',
        'my-account',
        'investor-documents',
        'investor-messages',
    ],
};

export const sortRoutesByRole = (routes, roleKey) => {
    const orderList = routeMaps[roleKey] || [];
    const orderMap = new Map(orderList.map((key, idx) => [key, idx]));

    return routes.slice().sort((a, b) => {
        const orderA = orderMap.has(a.key) ? orderMap.get(a.key) : Infinity;
        const orderB = orderMap.has(b.key) ? orderMap.get(b.key) : Infinity;
        return orderA - orderB;
    });
};
